export const localStorageKeys = ["default_currency", "default_location", "default_project"];
